// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  // DialogContentText,
  Tooltip,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  TextField,
  Checkbox,
  Button,
  Table,
  TableRow,
  TableCell,
  Divider,
  // Divider,
  // FormControlLabel,
  // Switch,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
// import MDBadge from "theme/components/MDBadge";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";

import Editor from "react-simple-wysiwyg";
import { useAuthUser } from "react-auth-kit";
import { useAwaitDialog } from "app/components/status_dialog";

function CampaignSubscriptionsPage() {
  const pageTitle = "Campaign Subscriptions";
  usePageTitle(pageTitle);
  const navigate = useNavigate();

  const auth = useAuthUser();
  const accountInfo = auth();

  const statusDialog = useAwaitDialog();
  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);

  const [currency, setCurrency] = useState(null);
  const [subscriptions, setSubscriptions] = useState([]);
  const [campaignPackages, setCampaignPackages] = useState([]);
  const [openPackagesDialog, setOpenPackagesDialog] = useState(false);

  const [tableRows, setTableRows] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedPackageObject, setSelectedPackageObject] = useState(null);
  const [packageDuration, setPackageDuration] = useState(1);
  const [quantity, setQuantity] = useState(1);
  const [openPurchasePackageDialog, setOpenPurchasePackageDialog] = useState(false);

  const tableColumns = [
    { Header: "Plan", accessor: "plan", align: "left" },
    { Header: "Cap", accessor: "cap", align: "left" },
    { Header: "Used", accessor: "used", align: "left" },
    { Header: "Available", accessor: "balance", align: "left" },
    { Header: "Purchased On", accessor: "start", align: "center" },
    { Header: "Expires On", accessor: "end", align: "center" },
    { Header: "Status", accessor: "status", align: "center" },
  ];

  const buildRateRows = (data) => {
    const rows = [];
    data.map((row) => {
      let statusColor = "error";
      if (row.status) {
        statusColor = "success";
      }

      rows.push({
        plan: row.plan,
        cap: row.cap,
        used: row.used,
        balance: `${row.bal} (${((row.bal / row.cap) * 100).toFixed(2)}%)`,
        start: row.start,
        end: row.end,
        status: (
          <MDBox>
            <Icon color={statusColor}>{row.status ? "check_circle" : "cancel"}</Icon>
          </MDBox>
        ),
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("portal/campaigns/subscriptions.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCurrency(result.data.currency);
            const rows = buildRateRows(result.data.data.subscriptions);
            setSubscriptions(rows);
            setCampaignPackages(result.data.data.packages);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function subscribe() {
    if (selectedPackage === null) {
      setSeverity("error");
      setErrMsg("Subscription plan is required.");
      setOpen(true);
      return;
    }

    if (packageDuration === null) {
      setSeverity("error");
      setErrMsg("Subscription duration is required.");
      setOpen(true);
      return;
    }

    if (quantity === null) {
      setSeverity("error");
      setErrMsg("Subscription quantity is required.");
      setOpen(true);
      return;
    }

    setOpenPurchasePackageDialog(false);
    setShowLoading(true);
    const json = {
      package: selectedPackage,
      duration: packageDuration,
      quantity: quantity,
    };

    await axios
      .post("portal/campaigns/subscriptions/purchase.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");

          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openPurchasePackageDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox align="center" mb={1}>
            <MDTypography variant="h6" fontSize={24}>
              Purchase a Plan
            </MDTypography>
          </MDBox>
          <MDBox>
            <Divider />
          </MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mb={3}>
            <MDBox>
              <Grid container spacing={3}>
                <Grid item xs={12} md={8} lg={8}>
                  <MDBox mt={1}>
                    <FormControl sx={{ minWidth: 120, width: "100%" }}>
                      <InputLabel>Choose Plan</InputLabel>
                      <Select
                        label="Choose Plan"
                        onChange={(e) => {
                          let found = campaignPackages.every((pck) => {
                            if (pck.reference === e.target.value) {
                              setSelectedPackageObject(pck);
                              return false;
                            }
                            return true;
                          });
                          setSelectedPackage(e.target.value);
                        }}
                        sx={{ padding: "12px", paddingLeft: "3px" }}
                      >
                        {campaignPackages.map((pckg) => (
                          <MenuItem value={pckg.reference}>{pckg.title}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                  <MDBox>
                    <MDInput
                      name="quantity"
                      margin="dense"
                      label="Quantity"
                      type="number"
                      fullWidth
                      variant="outlined"
                      value={quantity}
                      onChange={(e) => setQuantity(e.target.value)}
                      onBlur={() => {
                        let value = parseInt(quantity, 10);
                        if (isNaN(value) || value < 1) {
                          value = 1;
                        }
                        setQuantity(value);
                      }}
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-", "."].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      inputProps={{
                        min: 1,
                        step: 1,
                      }}
                    />
                  </MDBox>
                </Grid>
              </Grid>

              <MDBox mt={4}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Duration</InputLabel>
                  <Select
                    label="Duration"
                    onChange={(e) => {
                      if (selectedPackageObject.price === 0) {
                        setPackageDuration(1);
                      } else {
                        setPackageDuration(e.target.value);
                      }
                    }}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                    value={packageDuration}
                  >
                    {[1, 2, 3, 6, 9, 12].map((x) => (
                      <MenuItem value={x}>{`${x} month${x > 1 ? "s" : ""}`}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </MDBox>
              {selectedPackage && (
                <MDBox mt={4}>
                  <Table>
                    <TableRow>
                      <TableCell>
                        <MDTypography fontSize={12}>Price</MDTypography>
                      </TableCell>
                      <TableCell>
                        <MDTypography align="right" fontSize={12}>
                          {`${currency}${(
                            (selectedPackageObject.price * quantity * packageDuration) /
                            100
                          ).toLocaleString("en", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}`}
                        </MDTypography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <MDTypography fontSize={12}>VAT</MDTypography>
                      </TableCell>
                      <TableCell>
                        <MDTypography align="right" fontSize={12}>
                          {`${currency}${(
                            (selectedPackageObject.price * quantity * packageDuration * 0.075) /
                            100
                          ).toLocaleString("en", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}`}
                        </MDTypography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <MDTypography fontSize={14} fontWeight="bold">
                          Total
                        </MDTypography>
                      </TableCell>
                      <TableCell>
                        <MDTypography align="right" fontSize={14} fontWeight="bold">
                          {`${currency}${(
                            (selectedPackageObject.price * quantity * packageDuration * 0.075 +
                              selectedPackageObject.price * quantity * packageDuration) /
                            100
                          ).toLocaleString("en", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}`}
                        </MDTypography>
                      </TableCell>
                    </TableRow>
                  </Table>
                </MDBox>
              )}
            </MDBox>
            {selectedPackage && packageDuration && (
              <MDBox mt={3}>
                <Alert severity="info">
                  <MDTypography variant="h6" fontSize={12}>
                    Unused balances from active plan will be added.
                  </MDTypography>
                </Alert>
              </MDBox>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenPurchasePackageDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              subscribe();
            }}
          >
            Purchase
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openPackagesDialog} fullWidth maxWidth="lg">
        <DialogTitle>
          <MDBox align="center" mb={3}>
            Subscription Plans
          </MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <Grid container spacing={3}>
              {campaignPackages.map((pckg) => (
                <Grid item xs={12} md={3} lg={3}>
                  <Card>
                    <MDBox p={0}>
                      <MDBox align="center" mt={1}>
                        <MDTypography variant="h6">{pckg.title}</MDTypography>
                        <MDTypography fontSize={14}>{`${accountInfo.account.currency}${(
                          pckg.price / 100
                        ).toLocaleString("en", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}`}</MDTypography>
                        <MDTypography fontSize={12}>{pckg.duration} days</MDTypography>
                      </MDBox>
                      <MDBox mt={2}>
                        <Table>
                          <TableRow>
                            <TableCell>
                              <MDTypography>
                                <MDTypography fontSize={12}>Capped At</MDTypography>
                              </MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography align="right" fontSize={12}>
                                {pckg.sales_cap.toLocaleString("en", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <MDTypography fontSize={12}>Sales Overage</MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography align="right" fontSize={12}>
                                {pckg.is_sales_fee_percentage
                                  ? `${(pckg.sales_fee * 100).toFixed(2)}%`
                                  : `${accountInfo.account.currency}${(
                                      pckg.sales_fee / 100
                                    ).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}`}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          {pckg.is_sales_fee_percentage && (
                            <>
                              {pckg.sales_fee_min && (
                                <TableRow>
                                  <TableCell>
                                    <MDTypography fontSize={12}>Sales Fee (min)</MDTypography>
                                  </TableCell>
                                  <TableCell>
                                    <MDTypography align="right" fontSize={12}>{`${
                                      accountInfo.account.currency
                                    }${(pckg.sales_fee_min / 100).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}`}</MDTypography>
                                  </TableCell>
                                </TableRow>
                              )}

                              {pckg.sales_fee_max && (
                                <TableRow>
                                  <TableCell>
                                    <MDTypography fontSize={12}>Sales Fee (cap)</MDTypography>
                                  </TableCell>
                                  <TableCell>
                                    <MDTypography align="right" fontSize={12}>{`${
                                      accountInfo.account.currency
                                    }${(pckg.sales_fee_max / 100).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}`}</MDTypography>
                                  </TableCell>
                                </TableRow>
                              )}
                            </>
                          )}
                        </Table>
                      </MDBox>
                      <MDBox mt={0}>
                        <Table>
                          {/* <TableRow>
                            <TableCell>
                              <MDTypography fontSize={12}>Data Capture Cap</MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography align="right" fontSize={12}>
                                {pckg.data_cap.toLocaleString("en", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })}
                              </MDTypography>
                            </TableCell>
                          </TableRow> */}
                          <TableRow>
                            <TableCell>
                              <MDTypography fontSize={12}>Data Overage</MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography align="right" fontSize={12}>{`${
                                accountInfo.account.currency
                              }${(pckg.data_fee / 100).toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}`}</MDTypography>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Grid>
              ))}
            </Grid>
            <MDBox mt={3}>
              <Alert severity="info">
                <MDTypography variant="h6" fontSize={12}>
                  Overages apply only when plan cap is exceeded.
                </MDTypography>
              </Alert>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenPackagesDialog(false);
            }}
            color="dark"
            variant="outlined"
            iconOnly
            circular
          >
            <Icon>close</Icon>
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox pt={1} pb={3}>
        {pageLoaded && (
          <MDBox align="right">
            <MDBox>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={3}>
                  <MDBox align="center">
                    <MDBox mb={3}>
                      <MDTypography variant="h6" fontSize={48}>
                        <Icon>receipt</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                        Purchase a subscription plan suitable for your field operations
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={5} mb={3} display="flex" alignItems="center" justifyContent="center">
                      {accountInfo.account.plan.code === "PAG" && (
                        <MDBox>
                          <MDButton
                            color="warning"
                            onClick={() => setOpenPackagesDialog(true)}
                            variant="outlined"
                            startIcon={<>{accountInfo.account.currency}</>}
                          >
                            View Pricing
                          </MDButton>
                          &nbsp;
                          <MDButton
                            sx={{ ml: { xs: 1 } }}
                            variant="contained"
                            color="dark"
                            onClick={() => {
                              setSelectedPackage(null);
                              setPackageDuration(1);
                              setQuantity(1);
                              setOpenPurchasePackageDialog(true);
                            }}
                            startIcon={<Icon>add</Icon>}
                          >
                            Purchase Plan
                          </MDButton>
                        </MDBox>
                      )}
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={5}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={0}>
                  <MDBox p={2} display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="h6" fontWeight="medium">
                      Subscriptions
                    </MDTypography>
                  </MDBox>
                  <MDBox mt={0} mb={3}>
                    <DataTable
                      table={{ columns: tableColumns, rows: subscriptions }}
                      isSorted={false}
                      entriesPerPage={false}
                      showTotalEntries={true}
                      noEndBorder
                    />
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CampaignSubscriptionsPage;
